import React, { useState, useEffect, Fragment } from "react";
import CtaBtn from "../UIElements/CtaBtn";
import { Transition } from '@headlessui/react';
import * as amplitude from '@amplitude/analytics-browser';

function ValidateEmail(inputText)
{
	var mailformat = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
	if(!inputText.match(mailformat))
	{
		return false;
    }
    return true;
}

export default function NewsletterTile() {

    const intialiseInfo = {
        email: '',
        country: 'uk'
      }

    const [isClient, setIsClient] = useState(false)
    const [ complete, setComplete ] = useState(false);
    const [ submitted, setSubmitted ] = useState(false);
    const [ userInfo, setUserInfo ] = useState(intialiseInfo);

    const handleUpdateUserInfo = (attr, value) => {
        const info = {...userInfo};
        info[attr] = value;
        setUserInfo(info);
        if (info.email !== '' && ValidateEmail(info.email)) {
          setComplete(true);
        } else {
          setComplete(false);
        }
      };

    const handleSubmit = async () => {
        amplitude.setUserId(userInfo.email);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userInfo)
        };
        const response = await fetch('https://sj1uapt1x3.execute-api.eu-west-1.amazonaws.com/prod/newsletter', requestOptions);
        const data = await response.json();
        if (data && data.status && data.status === "success") {
            setSubmitted(true);
            setUserInfo(intialiseInfo);
            setComplete(false);
            amplitude.track('Newsletter Sign Up');
        }
    }
    
 
    useEffect(() => {
        setIsClient(true)
    }, [])

    return (
        <div className="w-[280px] h-[240px] rounded-md bg-[#F5F8FF] p-5 space-y-2 mx-auto lg:mx-0">
            <div className="text-2xl font-semibold text-blue-700 text-center lg:text-left">
                <div>Subscribe </div>
                <div>to our Newsletter</div>
            </div>
            <Transition
                as={Fragment}
                show={submitted}
                enter="ease-out duration-300 delay-100"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-100"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                <div className="inline-block align-bottom  px-4 pt-5 pb-4 text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 mx-6 md:mx-0 my-6 md:mt-0">
                    <div>
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-ful">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-plum-700">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z" />
                        </svg>
                    </div>
                    <div className="mt-3 sm:mt-5">
                        <p className="text-sm text-center text-plum-900">You're all set. Watch out for a confirmation email</p>
                    </div>
                    </div>
                </div>
                </Transition>
                <Transition
                as={Fragment}
                show={!submitted}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-100"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                ><div>
                <div className="text-light text-sm text-center lg:text-left mb-2">Get the lastest news about The Information Lab and data industry</div>
                <div>
                    {isClient ? <input
                        id="email-address"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        className="w-full flex-auto rounded-md border-0 bg-white px-3.5 py-2 shadow-xs ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6 mb-2"
                        placeholder="Your email address"
                        value={userInfo.email || ''}
                        onChange={(e) => {
                            handleUpdateUserInfo('email', e.target.value)
                        }}
                    /> : null}
                </div>
                {complete ? 
                    <CtaBtn label={<span className="text-xs">Subscribe now</span>} colour={'blue'} size="small" onClick={handleSubmit} className={'flex flex-1 justify-end'}/> :
                    <CtaBtn label={<span className="text-xs">Subscribe now</span>} disabled={true} size="small" onClick={() => console.log('Form invalid')} className={'flex flex-1 justify-end'}/>
                }
                </div>
            </Transition>
        </div>
    )
}